export default {
  create: {
    method: 'post',
    url: '/client/partner/bank/cooperatorId'
  },
  update: {
    method: 'put',
    url: '/client/partner/bank/cooperatorId/bankId'
  },
  delete: {
    method: 'delete',
    url: '/client/partner/bank/cooperatorId/delete'
  },
  detail: {
    method: 'get',
    url: '/client/partner/bank/cooperatorId/bankId'
  },
  archive: {
    method: 'delete',
    url: '/client/partner/bank/archive'
  },
  restore: {
    method: 'put',
    url: '/client/partner/bank/restore'
  }
}
